import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export const mcpOrgCredentialsQueryKey = (orgId: string | undefined) => [
  "mcpOrgCredentials",
  orgId,
];

/** Lists the org's MCP server tokens, one record per server that has one. */
export function useMcpOrgCredentials(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();

  return useQuery({
    queryKey: mcpOrgCredentialsQueryKey(orgId),
    queryFn: ({ signal }) =>
      mcpRegistryService.listOrgCredentials(orgId!, { abortSignal: signal }),
    enabled: orgId !== undefined,
    staleTime: 30_000,
  });
}
